// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import CodeBookH1 from './CodeBookH1'
import CodebookCodePageContainer from './CodebookCodePageContainer'
import { MemoModalProvider } from './modal/MemoModalProvider';
import { useCollapseActions } from 'hooks/codes/useCollapseActions';

const CodeBook = ({ codes, projectID, codeID, hasEditPermission }) => {
  const { collapseCode, expandCode } = useCollapseActions(projectID);
  
  const onCollapseClicked = (codeID, collapsed) => {
    if (collapsed) {
      expandCode(codeID);
    } else {
      collapseCode(codeID);
    }
  };

  const codeEntries = (codes || []).map((code) => {
    return (
      <CodeBookH1
        key={code.id}
        code={code}
        projectID={projectID}
        onCollapseClicked={onCollapseClicked}
        hasEditPermission={hasEditPermission}
      />
    );
  });

  const sidePadding = 30;

  return (
    <div style={{
      height: "100%",
      paddingLeft: sidePadding,
      paddingBottom: 0,
      paddingTop: 0,
      margin: 0,
      width: "100%",
      display: "flex",
      flexDirection: "column"
    }}>
      {codeID &&
        <MemoModalProvider>
          <CodebookCodePageContainer
            codeID={codeID}
            projectID={projectID}
            hasEditPermission={hasEditPermission}
          />
        </MemoModalProvider>
      }
      <div style={{ flex: 1, overflow: "hidden" }}>
        <Scrollbars
          autoHide
          style={{
            height: "100%",
            padding: 10,
            margin: 0,
            width: "100%"
          }}
        >
          <div style={{ padding: "0px 30px 30px 0px" }}>
            {codeEntries}
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default CodeBook;